module.exports = __webpack_public_path__ + "img/security.6165f618.png";